<template>
  <v-sonner position="bottom-right" />
</template>

<script lang="ts" setup>
import { VSonner } from 'vuetify-sonner';
import 'vuetify-sonner/style.css';
</script>
